module.exports = __webpack_public_path__ + "img/instargram-icon.529bea77.svg";